import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type GetMailTemplatesQueryVariables = {
  pgid?: Types.Maybe<Types.Scalars['String']>
};


export type GetMailTemplatesQuery = (
  { __typename?: 'Query' }
  & { mailTemplates: Array<(
    { __typename?: 'MailTemplate' }
    & Pick<Types.MailTemplate, '_id' | 'name' | 'provingGroundId' | 'to' | 'cc' | 'subject' | 'body' | 'type' | 'inactive'>
    & { provingGround: Types.Maybe<(
      { __typename?: 'ProvingGround' }
      & Pick<Types.ProvingGround, '_id' | 'title'>
    )> }
  )> }
);

export type CreateMailTemplateMutationVariables = {
  name: Types.Scalars['String'],
  provingGroundId?: Types.Maybe<Types.Scalars['String']>,
  to?: Types.Maybe<Types.Scalars['String']>,
  cc?: Types.Maybe<Types.Scalars['String']>,
  subject?: Types.Maybe<Types.Scalars['String']>,
  body?: Types.Maybe<Types.Scalars['String']>,
  type: Types.MailTemplateType,
  inactive?: Types.Maybe<Types.Scalars['Boolean']>
};


export type CreateMailTemplateMutation = (
  { __typename?: 'Mutation' }
  & { createMailTemplate: (
    { __typename?: 'MailTemplate' }
    & Pick<Types.MailTemplate, '_id'>
  ) }
);

export type UpdateMailTemplateMutationVariables = {
  id: Types.Scalars['ID'],
  name: Types.Scalars['String'],
  provingGroundId?: Types.Maybe<Types.Scalars['String']>,
  to?: Types.Maybe<Types.Scalars['String']>,
  cc?: Types.Maybe<Types.Scalars['String']>,
  subject?: Types.Maybe<Types.Scalars['String']>,
  body?: Types.Maybe<Types.Scalars['String']>,
  type: Types.MailTemplateType,
  inactive?: Types.Maybe<Types.Scalars['Boolean']>
};


export type UpdateMailTemplateMutation = (
  { __typename?: 'Mutation' }
  & { updateMailTemplate: Array<(
    { __typename?: 'MailTemplate' }
    & Pick<Types.MailTemplate, '_id'>
  )> }
);

export type DeleteMailTemplatesMutationVariables = {
  ids: Array<Types.Scalars['ID']>
};


export type DeleteMailTemplatesMutation = (
  { __typename?: 'Mutation' }
  & { deleteMailTemplate: Array<(
    { __typename?: 'MailTemplate' }
    & Pick<Types.MailTemplate, '_id'>
  )> }
);

export const GetMailTemplatesDocument = gql`
    query getMailTemplates($pgid: String) {
  mailTemplates(filter: {provingGroundId: {EQ: $pgid}}) {
    _id
    name
    provingGroundId
    provingGround {
      _id
      title
    }
    to
    cc
    subject
    body
    type
    inactive
  }
}
    `;

    export function useGetMailTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMailTemplatesQuery, GetMailTemplatesQueryVariables>) {
      return ApolloReactHooks.useQuery<GetMailTemplatesQuery, GetMailTemplatesQueryVariables>(GetMailTemplatesDocument, baseOptions);
    };
      export function useGetMailTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMailTemplatesQuery, GetMailTemplatesQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<GetMailTemplatesQuery, GetMailTemplatesQueryVariables>(GetMailTemplatesDocument, baseOptions);
      };
      
export type GetMailTemplatesQueryHookResult = ReturnType<typeof useGetMailTemplatesQuery>;
export type GetMailTemplatesQueryResult = ApolloReactCommon.QueryResult<GetMailTemplatesQuery, GetMailTemplatesQueryVariables>;
export const CreateMailTemplateDocument = gql`
    mutation createMailTemplate($name: String!, $provingGroundId: String, $to: String, $cc: String, $subject: String, $body: String, $type: MailTemplateType!, $inactive: Boolean) {
  createMailTemplate(input: {name: $name, provingGroundId: $provingGroundId, to: $to, cc: $cc, subject: $subject, body: $body, type: $type, inactive: $inactive}) {
    _id
  }
}
    `;
export type CreateMailTemplateMutationFn = ApolloReactCommon.MutationFunction<CreateMailTemplateMutation, CreateMailTemplateMutationVariables>;

    export function useCreateMailTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMailTemplateMutation, CreateMailTemplateMutationVariables>) {
      return ApolloReactHooks.useMutation<CreateMailTemplateMutation, CreateMailTemplateMutationVariables>(CreateMailTemplateDocument, baseOptions);
    };
export type CreateMailTemplateMutationHookResult = ReturnType<typeof useCreateMailTemplateMutation>;
export type CreateMailTemplateMutationResult = ApolloReactCommon.MutationResult<CreateMailTemplateMutation>;
export type CreateMailTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateMailTemplateMutation, CreateMailTemplateMutationVariables>;
export const UpdateMailTemplateDocument = gql`
    mutation updateMailTemplate($id: ID!, $name: String!, $provingGroundId: String, $to: String, $cc: String, $subject: String, $body: String, $type: MailTemplateType!, $inactive: Boolean) {
  updateMailTemplate(filter: {_id: {EQ: $id}}, update: {set: {name: $name, provingGroundId: $provingGroundId, to: $to, cc: $cc, subject: $subject, body: $body, type: $type, inactive: $inactive}}) {
    _id
  }
}
    `;
export type UpdateMailTemplateMutationFn = ApolloReactCommon.MutationFunction<UpdateMailTemplateMutation, UpdateMailTemplateMutationVariables>;

    export function useUpdateMailTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMailTemplateMutation, UpdateMailTemplateMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdateMailTemplateMutation, UpdateMailTemplateMutationVariables>(UpdateMailTemplateDocument, baseOptions);
    };
export type UpdateMailTemplateMutationHookResult = ReturnType<typeof useUpdateMailTemplateMutation>;
export type UpdateMailTemplateMutationResult = ApolloReactCommon.MutationResult<UpdateMailTemplateMutation>;
export type UpdateMailTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateMailTemplateMutation, UpdateMailTemplateMutationVariables>;
export const DeleteMailTemplatesDocument = gql`
    mutation deleteMailTemplates($ids: [ID!]!) {
  deleteMailTemplate(filter: {_id: {IN: $ids}}) {
    _id
  }
}
    `;
export type DeleteMailTemplatesMutationFn = ApolloReactCommon.MutationFunction<DeleteMailTemplatesMutation, DeleteMailTemplatesMutationVariables>;

    export function useDeleteMailTemplatesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMailTemplatesMutation, DeleteMailTemplatesMutationVariables>) {
      return ApolloReactHooks.useMutation<DeleteMailTemplatesMutation, DeleteMailTemplatesMutationVariables>(DeleteMailTemplatesDocument, baseOptions);
    };
export type DeleteMailTemplatesMutationHookResult = ReturnType<typeof useDeleteMailTemplatesMutation>;
export type DeleteMailTemplatesMutationResult = ApolloReactCommon.MutationResult<DeleteMailTemplatesMutation>;
export type DeleteMailTemplatesMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteMailTemplatesMutation, DeleteMailTemplatesMutationVariables>;